import { render, staticRenderFns } from "./EcgViewComponent.vue?vue&type=template&id=9a34e976"
import script from "./EcgViewComponent.vue?vue&type=script&lang=js"
export * from "./EcgViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports